import getApi, {createWrapper} from '@web/helpers/api'

import {PointPromotionApplicablePageSetValues, GetCardPromotionResponse, GetPointPromotionResponse} from './interfaces'

type OrderSheetProductId = string

const api = getApi(`/orderApi`)

export type GetCardPromotionParams = {
    orderSheetId: string
    cardPromotionRequest: {
        /** 상품번호 - 쿠폰적용할인금액 */
        selectedDiscountAmountsByOrderSheetItemId: Record<OrderSheetProductId, number>
        /** 멤버십 구독 여부 */
        membershipSubscribed: boolean
        /** 프로모션 정보 조회할 CardCompanyCode */
        cardCompanyCodes: Array<string>
    }
    pageSet: PointPromotionApplicablePageSetValues
}

const ApiRoutePathMap: Record<'cardPromotion', Record<PointPromotionApplicablePageSetValues, string>> = {
    cardPromotion: {
        EASY_BOOK_CHECKOUT: '/orderSheet/easyBooking/pointPromotion',
        MALL_CHECKOUT: '/orderSheet/mall/pointPromotion',
        SELLER_CHECKOUT: '/orderSheet/seller/cardPromotion',
    },
}

/** 카드 프로모션 정보 재조회 */
async function getCardPromotions({pageSet, ...restParams}: GetCardPromotionParams) {
    return createWrapper<GetCardPromotionResponse | GetPointPromotionResponse>(
        api.post(ApiRoutePathMap['cardPromotion'][pageSet], restParams),
    )
}

export default {getCardPromotions}
